import { NgStyle } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, Input, viewChild } from '@angular/core';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { MultisiteFlagComponent } from '../../flag/multisite-flag.component';
import { MultisiteSwitchComponent } from '../multisite-switch.component';

@Component({
    selector: 'multisite-switch-simple',
    templateUrl: './multisite-switch-simple.component.html',
    styleUrls: ['./../multisite-switch.component.scss'],
    standalone: true,
    imports: [MultisiteFlagComponent, ToggleModule, NgStyle],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteSwitchSimpleComponent extends MultisiteSwitchComponent implements AfterViewInit {
    @Input()
    simpleMultisite = true;
    @Input()
    headerSelector = false;

    protected override asyncCd = false;
    override readonly hideUpElement = viewChild<ElementRef<HTMLElement>>('hideUpElSimple');

    protected toggleService = inject(ToggleService);
    readonly toggleGroup = 'group';

    open(id: NToggle.TId): void {
        this.toggleService.open(id);
    }
    toggle(id: NToggle.TId): void {
        (this, this.toggleService.toggle(id));
    }
}
